/**
 * VixoKart Theme — Product Page Enhancements
 * Product-scoped gallery, zoom, sticky cart, and buy-now interactions.
 * Loaded deferred on product pages only.
 */

'use strict';

(function initProductPage() {
  const gallery = document.querySelector('[data-product-gallery]');
  const form = document.querySelector('[data-type="add-to-cart-form"]');
  const stickyBar = document.getElementById('sticky-cart-bar');
  const buyArea = document.querySelector('.product-buy');

  if (gallery) {
    // All main images are already in the DOM (see main-product.liquid) —
    // switching images is just a class toggle, not a new image request,
    // so selection is instant even on a slow connection.
    const mainImages = Array.from(gallery.querySelectorAll('.product-gallery__main-img'));
    const mainFrame = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('.product-gallery__thumb'));

    const setActiveIndex = (index) => {
      if (index < 0 || index >= mainImages.length) return;
      mainImages.forEach((el, i) => {
        const active = i === index;
        el.classList.toggle('active', active);
        el.setAttribute('tabindex', active ? '0' : '-1');
        // Video/model slides are wrapped in a <div>, not an <img> — when a
        // slide is swiped/clicked away from, stop anything playing inside
        // it so audio/video doesn't keep running behind the new slide.
        if (!active) {
          const video = el.querySelector && el.querySelector('video');
          if (video && !video.paused) video.pause();
          const iframe = el.querySelector && el.querySelector('iframe');
          if (iframe && iframe.src) iframe.src = iframe.src; // reload = stop playback
        }
      });
      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('active', active);
        thumb.setAttribute('aria-current', String(active));
      });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setActiveIndex(index));
    });

    const getActiveIndex = () => Math.max(0, mainImages.findIndex((img) => img.classList.contains('active')));
    const getActiveImage = () => mainImages[getActiveIndex()];

    const stepImage = (direction) => {
      const activeIndex = getActiveIndex();
      const nextIndex = direction > 0
        ? Math.min(mainImages.length - 1, activeIndex + 1)
        : Math.max(0, activeIndex - 1);
      setActiveIndex(nextIndex);
    };
    // Arrow key navigation on the main gallery
gallery.addEventListener('keydown', (event) => {
  if (event.key === 'ArrowLeft') {
    event.preventDefault();
    stepImage(-1);
  } else if (event.key === 'ArrowRight') {
    event.preventDefault();
    stepImage(1);
  }
});


    if (mainFrame && thumbs.length > 1) {
      let startX = 0;
      mainFrame.addEventListener('touchstart', (event) => {
        startX = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });
      mainFrame.addEventListener('touchend', (event) => {
        const endX = event.changedTouches[0]?.clientX || 0;
        const delta = endX - startX;
        if (Math.abs(delta) < 36) return;
        stepImage(delta < 0 ? 1 : -1);
      }, { passive: true });
    }

    // Tapping/clicking the main image itself opens it larger — no separate
    // "View larger" button needed. Each main image carries data-gallery-zoom,
    // role="button" (see main-product.liquid); only the active one is
    // interactive (the rest sit at tabindex="-1" and are visually hidden),
    // so this also works from the keyboard (Enter/Space) for accessibility.
    // Inside the modal, side arrows let you step through the rest of the
    // product's images without closing and reopening the zoom.
    const openImageZoom = () => {
      const activeImg = getActiveImage();
      if (!activeImg) return;
      const source = activeImg.dataset.zoomSrc || activeImg.currentSrc || activeImg.src;
      if (!source) return;
      const hasMultiple = mainImages.length > 1;
      const modal = document.createElement('div');
      modal.className = 'product-image-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Large product image');
      modal.innerHTML = `
        <button class="product-image-modal__close" type="button" aria-label="Close image">×</button>
        ${hasMultiple ? '<button class="product-image-modal__nav product-image-modal__nav--prev" type="button" aria-label="Previous image"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>' : ''}
        <img src="${source}" alt="${activeImg.alt || ''}">
        ${hasMultiple ? '<button class="product-image-modal__nav product-image-modal__nav--next" type="button" aria-label="Next image"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button>' : ''}
      `;
      document.body.appendChild(modal);
      document.body.classList.add('product-image-modal-open');

      const modalImg = modal.querySelector('img');
      const prevNavBtn = modal.querySelector('.product-image-modal__nav--prev');
      const nextNavBtn = modal.querySelector('.product-image-modal__nav--next');

      const updateModalNavState = () => {
        if (!hasMultiple) return;
        const activeIndex = getActiveIndex();
        if (prevNavBtn) prevNavBtn.disabled = activeIndex <= 0;
        if (nextNavBtn) nextNavBtn.disabled = activeIndex >= mainImages.length - 1;
      };

      const stepModalImage = (direction) => {
        stepImage(direction);
        const img = getActiveImage();
        modalImg.src = img.dataset.zoomSrc || img.currentSrc || img.src;
        modalImg.alt = img.alt || '';
        updateModalNavState();
      };

      if (prevNavBtn) prevNavBtn.addEventListener('click', () => stepModalImage(-1));
      if (nextNavBtn) nextNavBtn.addEventListener('click', () => stepModalImage(1));
      updateModalNavState();

      const close = () => {
        modal.remove();
        document.body.classList.remove('product-image-modal-open');
        document.removeEventListener('keydown', onKeydown);
      };
      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('.product-image-modal__close')) close();
      });
      function onKeydown(event) {
        if (event.key === 'Escape') {
          close();
        } else if (event.key === 'ArrowLeft') {
          stepModalImage(-1);
        } else if (event.key === 'ArrowRight') {
          stepModalImage(1);
        }
      }
      document.addEventListener('keydown', onKeydown);
      modal.querySelector('.product-image-modal__close')?.focus();
    };

    // A single delegated listener covers all main images — only the
    // active (visible) one is reachable by click or keyboard since the
    // rest are visibility:hidden and tabindex="-1".
    if (mainFrame) {
      mainFrame.addEventListener('click', (event) => {
        const img = event.target.closest('.product-gallery__main-img[data-gallery-zoom]');
        if (img) openImageZoom();
      });
      mainFrame.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const img = event.target.closest('.product-gallery__main-img[data-gallery-zoom]');
        if (!img) return;
        event.preventDefault();
        openImageZoom();
      });
    }
  }

  if (stickyBar && buyArea && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting;
      stickyBar.classList.toggle('visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 });
    observer.observe(buyArea);
  }

  // Buy Now is Shopify's native dynamic checkout button rendered by
  // {{ form | payment_button }}. Shopify reads the selected variant and
  // quantity directly from the product form.
})();